import React, { useEffect, useRef } from "react";
import { ContextMenuProps } from "../types/types";
import { useTheme } from "../contexts/ThemeContext";

export const ContextMenu: React.FC<ContextMenuProps> = ({
  x,
  y,
  name,
  itemPath,
  onClose,
}) => {
  const { theme } = useTheme();
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose]);

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).catch(() => {});
    onClose();
  };

  return (
    <div
      ref={menuRef}
      style={{
        position: "fixed",
        top: y,
        left: x,
        backgroundColor: theme.surface,
        border: `1px solid ${theme.border}`,
        borderRadius: "6px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        zIndex: 1000,
        minWidth: "160px",
        overflow: "hidden",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        style={{
          padding: "6px 12px",
          fontSize: "11px",
          color: theme.textSecondary,
          borderBottom: `1px solid ${theme.border}`,
        }}
      >
        {name}
      </div>
      {[
        { label: "Copy name", value: name },
        { label: "Copy path", value: itemPath },
      ].map(({ label, value }) => (
        <div
          key={label}
          onClick={() => copyToClipboard(value)}
          style={{
            padding: "8px 12px",
            color: theme.text,
            cursor: "pointer",
            fontSize: "13px",
          }}
          onMouseEnter={(e) =>
            ((e.currentTarget as HTMLDivElement).style.backgroundColor = theme.hover)
          }
          onMouseLeave={(e) =>
            ((e.currentTarget as HTMLDivElement).style.backgroundColor = "transparent")
          }
        >
          {label}
        </div>
      ))}
    </div>
  );
};
